import { render, staticRenderFns } from "./ActivateAndResetPasswordConfirm.vue?vue&type=template&id=60bd4736&"
import script from "./ActivateAndResetPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./ActivateAndResetPasswordConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports